import React from 'react';
import styled from 'styled-components';
import { type MeritFormsProps } from './types';
import { MeritForm } from './MeritForm';
import { PAGE_COMMON_TEXT } from '../../lang';

export const MeritForms: React.FunctionComponent<MeritFormsProps> = (
  props: MeritFormsProps,
) => {
  const { data: merits = [] } = props;
  const hasMerits = merits.length > 0;

  return hasMerits ? (
    <Container>
      {merits.map((merit, index) => {
        return <MeritForm key={index} meritIndex={index} merit={merit} />;
      })}
    </Container>
  ) : (
    <div>{PAGE_COMMON_TEXT.NA}</div>
  );
};

const Container = styled.div`
  width: 100%;

  h3 {
    color: #951d1d;
    font-style: italic;
    padding: 0 1rem;
  }
`;
